import React from 'react';
import { Dialog } from '../../components/Dialogs';
import { BasicGrid } from '../../components/Grids';
import styled from '@emotion/styled';

class InfoGrid extends BasicGrid {
	static defaultProps = {
		...BasicGrid.defaultProps,
		isRefreshBtn: false,
		ctrlPanel: false,
		height: 280,
		// colWidths: [40, 40, '*', '25', '15', '15', '20'],
		api: '/find',
	};

	renderGridHeader() {
		const { TH } = this;
		const { info = [] } = this.props;
		return <tr>
			{
				info.map((item) => {
					return <TH.sortable sortKey={item.field} key={item.field}>{item.name}</TH.sortable>;
				})
			}
		</tr>;
	};

	renderGridBody(data, idx, allData) {
		const { info = [] } = this.props;
		return <>
			{
				info.map((item, index) => {
					return <td key={index}>{data[item.field]}</td>;
				})
			}
		</>;
	}
}

const EmpInfoWrapper = styled.div`
	display: flex;
	width: 100%;
	/* justify-content: space-between; */
	margin-bottom: 16px;
	flex-wrap: wrap;

	& > div {
		max-width: 100%;
		flex: 1;
	}

	.-title {
		font-weight: bold;
		margin-right: 16px;
	}

	.-content {
		word-wrap: break-word;
	}
`;

const EmpInfo = ({ emp }) => {
	return (
		<EmpInfoWrapper>
			<div>
				<span className='-title'>{OptionUtils.getLabel('global.normal', 'employeeNumber')}</span>
				<span className='-content'>{emp.empNo}</span>
			</div>
			<div>
				<span className='-title'>{OptionUtils.getLabel('global.normal', 'name')}</span>
				<span>{emp.name || emp.enName}</span>
			</div>
		</EmpInfoWrapper>
	);
};



export class CompTimeDialog extends Dialog {
	static defaultProps = {
		...Dialog.defaultProps,
		isOk: false,
		cancelText: OptionUtils.getLabel('global.normal', 'close'),
		height: 500,
		title: OptionUtils.getLabel('h2.am.ShiftingDialog', 'remainingCompensatoryHours')
	};

	renderBody() {
		const { emp, api, period } = this.props;

		return <>
			<EmpInfo emp={emp} />
			<InfoGrid
				api={`/api/${api}/compTimeDetail`}
				query={{
					empId: emp.id,
					period
				}}
				info={[
					{
						name: OptionUtils.getLabel('h2.am.ShiftingDialog', 'validStartDates'),
						field: 'startDate'
					},
					{
						name: OptionUtils.getLabel('h2.am.ShiftingDialog', 'closedEndDays'),
						field: 'endDate'
					},
					{
						name: OptionUtils.getLabel('hp.m4.m410070', 'available'),
						field: 'compTime'
					},
					{
						name: OptionUtils.getLabel('hp.m4.m410070', 'remaining'),
						field: 'lastCompTime'
					}
				]}
			/>
		</>;
	}
}

export class SpecialRestDialog extends Dialog {
	static defaultProps = {
		...Dialog.defaultProps,
		isOk: false,
		cancelText: OptionUtils.getLabel('global.normal', 'close'),
		height: 500,
		title: OptionUtils.getLabel('h2.am.ShiftingDialog', 'remainingSpecialHolidayHours')
	};

	renderBody() {
		const { emp, api, period } = this.props;

		return <>
			<EmpInfo emp={emp} />
			<InfoGrid
				api={`/api/${api}/specialRestDetail`}
				query={{
					empId: emp.id,
					period
				}}
				info={[
					{
						name: OptionUtils.getLabel('h2.am.ShiftingDialog', 'specialSabbaticalYear'),
						field: 'annualYear'
					},
					{
						name: OptionUtils.getLabel('h2.am.ShiftingDialog', 'validStartDates'),
						field: 'currStartDate'
					},
					{
						name: OptionUtils.getLabel('h2.am.ShiftingDialog', 'closedEndDays'),
						field: 'currEndDate'
					},
					{
						name: OptionUtils.getLabel('hp.m4.m410070', 'available'),
						field: 'currValue'
					},
					{
						name: OptionUtils.getLabel('hp.m4.m410070', 'remaining'),
						field: 'currRemainValue'
					}
				]}
			/>
		</>;
	}
}
